import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import Customers from "@/pages/Customers";
import CustomerCard from "@/pages/CustomerCard";
import Onboarding from "@/pages/Onboarding";
import KYC from "@/pages/KYC";
import Agreements from "@/pages/Agreements";
import Products from "@/pages/Products";
import Tasks from "@/pages/Tasks";
import Timeforing from "@/pages/Timeforing";
import Timer from "@/pages/Timer";
import Ansatt from "@/pages/Ansatt";
import Ressursplan from "@/pages/Ressursplan";
import Reports from "@/pages/Reports";
import YearEnd from "@/pages/YearEnd";
import Kvalitetskontroll from "@/pages/Kvalitetskontroll";
import Oppdragsutforelse from "@/pages/Oppdragsutforelse";
import Compliance from "@/pages/Compliance";
import Documents from "@/pages/Documents";
import Admin from "@/pages/Admin";
import Assistent from "@/pages/Assistent";
import Portal from "@/pages/Portal";
import SignAgreement from "@/pages/SignAgreement";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Laster…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  return (
    <Routes>
      <Route path="/portal/:token" element={<Portal />} />
      <Route path="/sign/:token" element={<SignAgreement />} />
      <Route path="/login" element={loading ? null : user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/leads" element={<Protected><Leads /></Protected>} />
      <Route path="/kunder" element={<Protected><Customers /></Protected>} />
      <Route path="/kunder/:id" element={<Protected><CustomerCard /></Protected>} />
      <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
      <Route path="/kyc" element={<Protected><KYC /></Protected>} />
      <Route path="/avtaler" element={<Protected><Agreements /></Protected>} />
      <Route path="/produkter" element={<Protected><Products /></Protected>} />
      <Route path="/oppgaver" element={<Protected><Tasks /></Protected>} />
      <Route path="/timeforing" element={<Protected><Timeforing /></Protected>} />
      <Route path="/timer" element={<Protected><Timer /></Protected>} />
      <Route path="/ansatt" element={<Protected><Ansatt /></Protected>} />
      <Route path="/ressursplan" element={<Protected><Ressursplan /></Protected>} />
      <Route path="/rapporter" element={<Protected><Reports /></Protected>} />
      <Route path="/arsregnskap" element={<Protected><YearEnd /></Protected>} />
      <Route path="/kvalitetskontroll" element={<Protected><Kvalitetskontroll /></Protected>} />
      <Route path="/oppdragsutforelse" element={<Protected><Oppdragsutforelse /></Protected>} />
      <Route path="/compliance" element={<Protected><Compliance /></Protected>} />
      <Route path="/dokumenter" element={<Protected><Documents /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="/assistent" element={<Protected><Assistent /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </AuthProvider>
  );
}
